export enum TimetableStatus {
  INITIAL,
  LOADING,
  READY,
  ERROR,
}
